/**
 * Shared helper for API path-object query keys used with `API().get({ path })`.
 */
export const pathKey = (path: string) => [{ path }] as const;
